module.exports = __webpack_public_path__ + "static/img/erm2.af9b9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/softwares/erm2.png
// module id = Sya9
// module chunks = 6